// extracted by mini-css-extract-plugin
export default {"video":"ApplicantInformationSection_video__Rz0xW","aboutMeText":"ApplicantInformationSection_aboutMeText__dypoA"};